import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import Box from '../../../components/Commons/Elements/Box'
import { getSellerSellingPrice } from '@/checkout-instore-legacy/seller/utils'

import Item from './Items/Item'

class MostPuchased extends React.Component {
  render() {
    const { profile } = this.props

    const hasAnyPreference =
      profile && (profile.brandPurchasedTag || profile.categoryPurchasedTag)

    if (!hasAnyPreference) return null

    return (
      <Box i18nTitleId="customerProfileMostPurchased">
        <table className="w-100">
          <tbody>
            {profile.productPurchasedTag &&
              profile.productPurchasedTag.details && (
                <tr valign="top" className="w-100">
                  <td className="mb6 w-100">
                    <FormattedMessage id="product" />
                    {':'}
                  </td>
                  <td className="mb6">
                    <Item
                      imageSrc={profile.productPurchasedTag.details.images[0]}
                      name={profile.productPurchasedTag.details.name}
                      totalPrice={getSellerSellingPrice(
                        profile.productPurchasedTag.details.sellers
                      )}
                      productId={profile.productPurchasedTag.details.productId}
                      skuId={profile.productPurchasedTag.details.id}
                    />
                  </td>
                </tr>
              )}
            {profile.brandPurchasedTag && (
              <tr valign="top">
                <td>
                  <div className="mb6">
                    <FormattedMessage id="customerProfileBrandPurchasedTag" />
                    {':'}
                  </div>
                </td>
                <td className="b">
                  <div className="mb6">{profile.brandPurchasedTag.data}</div>
                </td>
              </tr>
            )}
            {profile.categoryPurchasedTag && (
              <tr valign="top">
                <td>
                  <FormattedMessage id="customerProfileCategoryPurchasedTag" />
                  {':'}
                </td>
                <td className="b">{profile.categoryPurchasedTag.data}</td>
              </tr>
            )}
          </tbody>
        </table>
      </Box>
    )
  }
}

MostPuchased.propTypes = {
  profile: PropTypes.object,
  router: PropTypes.object,
}

export default injectIntl(MostPuchased)
